//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import { cleanObj } from '~/utils';
import { highestEducation } from '~/utils/jobs.js';
import { required, email } from '@/utils/validation.js';

export default {
  name: 'Basic',
  data() {
    return {
      highestEducation,
      isSameAddress: false,
      infoData: {},
      rules: {
        email: [required, email],
        phoneNumber: [required],
      },
    };
  },
  watch: {
    basicData: {
      handler(value) {
        this.infoData = JSON.parse(JSON.stringify(value));
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters('personal', ['basicData', 'isEdit']),
    ...mapGetters('user', ['token', 'avatarUrl']),
  },
  methods: {
    ...mapActions('personal', ['setBasicData', 'setIsEdit']),
    ...mapActions('user', [
      'setUserName',
      'setUserEngName',
      'setEmail',
      'setAvatarUrl',
    ]),
    handleInfo() {
      this.setBasicData(this.infoData);
      this.setIsEdit(true);
    },
    getUserInfo() {
      if (this.token) {
        this.$api('userGetUser')
          .then(data => {
            this.setBasicData(data);
            this.setAvatarUrl(data.url);
            this.setIsEdit(false);
          })
          .catch(() => {
            setTimeout(() => {
              this.getUserInfo();
            }, 500);
          });
      }
    },
    uploadAvatar(payload) {
      this.$api('uploadAvatar', payload, data => {
        this.setAvatarUrl(data);
      });
    },
    onSave() {
      this.$refs.infoData.validate(valid => {
        if (!valid) {
          return false;
        }

        let payload = cleanObj(this.basicData);

        this.$api('userUpdateUser', payload)
          .then(data => {
            const { name, engName, email } = data;
            this.setUserName(name);
            this.setUserEngName(engName);
            this.setEmail(email);
            this.setIsEdit(false);
            this.$message.success('編輯成功!');
            this.getUserInfo();
          })
          .catch(error => {
            this.$message.warning(`編輯失敗! ${error.message}`);
          });
      });
    },
  },
  mounted() {
    if (process.client && this.token) {
      this.getUserInfo();
    }
  },
};
